import { useQuery } from '@tanstack/react-query';
import keys from 'constants/queryKeys';
import { getDashboardConfig } from 'services/contentPlannerService';

// Default columns if API fails or returns empty
const DEFAULT_COLUMNS = [
  ['deadline', true],
  ['assignedTo', true],
  ['status', true],
  ['contentType', true],
];

const useDashboardConfig = () => {
  const query = useQuery({
    queryKey: keys.DashboardConfig,
    queryFn: async () => {
      const response = await getDashboardConfig();
      return response.data;
    },
    staleTime: Infinity, // Config rarely changes, keep cached indefinitely
    placeholderData: DEFAULT_COLUMNS, // Show default columns immediately while loading
  });

  return {
    ...query,
    data: query.data || DEFAULT_COLUMNS,
  };
};

export default useDashboardConfig;
